import { Root } from '@radix-ui/react-label';
import { forwardRef } from 'react';
import classNames from '@/lib/classNames';
import { type VariantProps, cva } from 'class-variance-authority';

const labelVariants = cva('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');

const Label = forwardRef<React.ElementRef<typeof Root>, React.ComponentPropsWithoutRef<typeof Root> & VariantProps<typeof labelVariants>>(({ className, ...props }, ref) => (
    <Root ref={ref} className={classNames(labelVariants(), className)} {...props} />
));
Label.displayName = Root.displayName;

export { Label };
